export default __webpack_public_path__ + "static/media/shapesColoringSample.e4e5aa0064198ac45fe6347491e84ce4.png";